/*!
  Machina, by Koding Themes
  navigation.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:load", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:unload", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:reorder", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
function megaMenuAutoClose() {
  //  Megamenu on mouse leave auto close
  var megaMenus = document.querySelectorAll(".has-megamenu, .has-dropdown");
  if (megaMenus.length > 0) {
    megaMenus.forEach(function (megamenu) {
      var currentMenuWrp = megamenu.querySelector(".sub-menu");
      if (currentMenuWrp != null) {
        currentMenuWrp.onmouseleave = function () {
          document.activeElement.blur();
        };
      }
    });
  }
  // Close mega menu on click btn
  var megaMenuClose = document.querySelectorAll(".close-megamenu");
  if (megaMenuClose.length > 0) {
    megaMenuClose.forEach(function (close) {
      var currentMenuWrp = close.closest(".sub-menu.megamenu");
      close.onclick = function () {
        if (currentMenuWrp != null) {
          currentMenuWrp.classList.add("hide-megamenu");
          setTimeout(function () {
            currentMenuWrp.classList.remove("hide-megamenu");
          }, 1000);
        }
      };
    });
  }
}
var _menuSliderInstance = null;
function headerMenuSlider() {
  if (
    document.querySelector(".menu-slider-active") != null &&
    document.querySelector(".menu-items-slider") != null
  ) {
    if (_menuSliderInstance) {
      _menuSliderInstance.destroy();
      _menuSliderInstance = null;
    }
    _menuSliderInstance = tns({
      container: ".menu-items-slider",
      items: 5,
      gutter: 0,
      slideBy: 1,
      controlsPosition: "bottom",
      navPosition: "bottom",
      mouseDrag: false,
      autoplay: false,
      loop: false,
      preventScrollOnTouch: "force",
      autoplayButtonOutput: false,
      controlsContainer: "#custom-menu-slider-controls",
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  (function () {
    //prevent scrollto top
    const paginationBtns = document.querySelectorAll(".menu-account");
    paginationBtns.forEach((item, i) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });
    //open menu
    function openMenu(e) {
      let t = e || document.body,
        a = t.querySelector(".menu-float__wrapper"),
        r = t.querySelectorAll(".menu-float__layout--primary a"),
        l = t.querySelectorAll(".menu-main");

      if (!a || r.length === 0) return;

      function closeAllMenus() {
        a.classList.remove("is-open-main-ignore");
        a.classList.remove("is-open");
        l.forEach(function (item) {
          item.classList.remove("is-active");
          var content = item.querySelector(".menu-float__menu-content");
          if (content) content.classList.remove("is-show");
        });
      }

      document.addEventListener("mousemove", function (e) {
        var target = e.target;
        if (target.closest(".menu-float__wrapper") == null) {
          if (a.classList.contains("is-open")) {
            closeAllMenus();
          }
        }
      });

      r.forEach(function (i) {
        var s = i ? i.dataset.childmenu : null;
        var m = s ? t.querySelector("." + s) : null;
        i.addEventListener("mouseenter", function (e) {
          var target = e.target;
          if (a.classList.contains("is-open")) {
            closeAllMenus();
          }
          if (i == target.closest(".menu-float__layout--primary a")) {
            a.classList.add("is-open-main-ignore");
            setTimeout(function () {
              a.classList.add("is-open");
            }, 100);
            if (m != null) {
              setTimeout(function () {
                m.classList.add("is-active");
              }, 100);
              setTimeout(function () {
                var content = m.querySelector(".menu-float__menu-content");
                if (content) {
                  content.classList.add("is-show");
                  if (content.offsetHeight > 600) {
                    m.style.height = "80vh";
                  }
                }
              }, 200);
            }
          }
        });
      });
    }
    openMenu();
  })();

  //js button click
  var keepMenuOpen = function keepMenuOpen() {
    if (!document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.add("show-sidebar-main");
      document.body.classList.add("active");
    }
  };

  var keepMenuClosed = function keepMenuClosed() {
    if (document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.remove("show-sidebar-main");
      document.body.classList.remove("active");
      var menuOverlay = document.querySelector(".menu-popup-background");

      if (menuOverlay) {
        menuOverlay.remove();
      }
    }
  };

  var closeSidebar = function closeSidebar(e) {
    var container = document.querySelector("#aside_main");
    if (!container) return;

    if (!container.contains(e.target)) {
      if (document.body.classList.contains("show-sidebar-main")) {
        keepMenuClosed();
      }
    }
  };

  const menuToggle = document.querySelector("li.js-menu-toggle-home");
  if(menuToggle != null) {
    menuToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      keepMenuOpen();
      document.body.addEventListener("click", closeSidebar);
    });
  }


  var closeBtn = document.querySelector("#aside_main .js-close-menu");
  if (closeBtn != null) {
    closeBtn.addEventListener("click", function (e) {
      keepMenuClosed();
      document.body.removeEventListener("click", closeSidebar);
    });
  }
});
